import * as actionTypes from "../../Action/actionTypes";

const initialState = {
  Sub_Event_Table_data: {
    columns: [
      {
        label: 'Sub Event Name',
        field: 'Sub_Event_Name',
        sort: 'asc'
      },
      {
        label: 'Start Date',
        field: 'Start_Date',
        sort: 'asc'
      },
      {
        label: 'End Date',
        field: 'End_Date',
        sort: 'asc'
      },
      {
        label: 'privacy',
        field: 'privacy',
        sort: 'asc'
      },
      {
        label: 'Type',
        field: 'type',
        sort: 'asc'
      },
      {
        label: 'Status',
        field: 'status',
        sort: 'asc'
      },
      {
        label: 'Action',
        field: 'action',
        sort: 'asc'
      }

    ],
  },
  Sub_Event_Table_data_For_Agenda: {
    columns: [
      {
        label: 'Index',
        field: 'Index',
        sort: 'asc'
      },
      {
        label: 'Name',
        field: 'Name',
        sort: 'asc'
      },
      {
        label: 'Start Date',
        field: 'Start_Date',
        sort: 'asc'
      },
      {
        label: 'End Date',
        field: 'End_Date',
        sort: 'asc'
      },
      {
        label: 'Create Agenda',
        field: 'action',
        sort: 'asc'
      }

    ],
    rows: []
  },
  // EventOrganizerData: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.DISPLAY_APPROVE_PARTICIPANT:
      return {
        ...state,
        // receptionData: action.value
      };
    default:
      return state;
  }
};

export default reducer;
